// extracted by mini-css-extract-plugin
module.exports = {"navbar":"_4S6NXgTlxyZTQ6O2mGWOd","border":"_3JfdYJLXKOBrQq3TIvEBad","logo":"_2GUbdl8_PGr2BbemGuzd01","wheat":"_2I2ZYEwQgutar2QxgHyF-g"};